var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0a2 2 0 0 1 1.4.6A2 2 0 0 1 26 2v28a2 2 0 0 1-.6 1.4 2 2 0 0 1-1.4.6H8a2 2 0 0 1-1.4-.6A2 2 0 0 1 6 30V2A2 2 0 0 1 6.6.6 2 2 0 0 1 8 0h16zm0 2H8v28h16V2zM14 26h4v2h-4v-2z",
    fillRule: "evenodd"
  })));
};
export default SvgPhone;